<template>
  <transition name="slide-fade">
    <div class="look-detail-new" v-if="hide">
      <div class="look-nav">
        <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
        <div class="look-nav-center">新增损耗</div>
        <div class="handle-wrapper" @click="handleData"><div class="icon-font">&#xe678;</div>提交</div>
      </div>
      <div class="look-detail-view-content">
        <div class="look-detail-view-list" style="z-index: 999">
          <div class="input-contain">
            <div class="input-title" style="padding-left: 0.89vw">批次号：</div>
            <DropDownInput type="3" :items="batchValue" content="" @sendValue="sendValueBatch" @sendInfo="showInfoBatch"></DropDownInput>
          </div>
          <div class="input-contain">
            <div class="input-title">烟叶简称：</div>
            <div class="input-wrapper" style="margin-right: 0">
              <input v-model="inputValue.materialName" disabled="true" placeholder=""/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">仓库位置：</div>
            <LoadingTreeStack :moduleType="moduleType"  :content="inputValue.siteName" :editCheckId="inputValue.siteId" v-on:sendInfo = "showDropInfo"></LoadingTreeStack>
          </div>
          <div class="input-contain">
            <div class="input-title">损耗重量：</div>
            <div class="input-suffix-wrapper" style="margin-right: 0">
              <input v-model="inputValue.lossWeight" placeholder=""/>
              <div class="input-suffix">（g）</div>
            </div>
          </div>
        </div>
        <div class="look-detail-view-list" style="z-index: 7">
          <div class="input-contain">
            <div class="input-title">损耗类型：</div>
            <div style="margin-right: 1vw">
              <DropDown content="请选择损耗类型" :items="loseData" v-on:sendInfo = "showInfo"></DropDown>
            </div>
          </div>
        </div>
        <div class="text-area-wrapper" style="margin-bottom: 1vw">
          <div class="text-area-title">损耗原因：</div>
          <textarea v-model="inputValue.lossReson" class="text-area-input"></textarea>
        </div>
        <div class="text-area-wrapper">
          <div class="text-area-title" style="padding-left: 1.78vw">备注：</div>
          <textarea v-model="inputValue.remark" class="text-area-input"></textarea>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import LoadingTreeStack from '../../../components/LoadingTreeStack.vue'
import DropDownInput from '../../../components/DropDownInput.vue'
import {vaildMaterialBath} from '../../../api/basic'
import {addLoss} from '../../../api/maintain'
import {noEmpty} from '../../../tools/methods'
export default {
  name: 'LookDetailNew',
  components: { DropDown, DropDownInput, LoadingTreeStack },
  data () {
    return {
      hide: false,
      batchValue: [],
      moduleType: '-1',
      loseData: [
        {name: '自然损耗', value: 1},
        {name: '霉变损耗', value: 2},
        {name: '造碎损耗', value: 3},
        {name: '虫害损耗', value: 4},
        {name: '碳化损耗', value: 5}
      ],
      inputValue: {
        batch: '',
        lossReson: '',
        lossType: '',
        lossWeight: '',
        materialName: '',
        remark: '',
        siteName: '',
        siteId: '',
        siteType: ''
      }
    }
  },
  created () {
    let _this = this
    setTimeout(function () {
      _this.hide = true
    }, 100)
    this.handleSearchBatchValue()
  },
  methods: {
    showInfoBatch: function (data) {
      console.log(data)
      this.inputValue.materialName = data.materialName
      this.inputValue.batch = data.batch
    },
    sendValueBatch: function (value) {
      this.handleSearchBatchValue(value)
    },
    handleSearchBatchValue: function (value) {
      let body = {
        batch: value || ''
      }
      vaildMaterialBath(body).then(res => {
        console.log(res)
        this.batchValue = res.data
      }).catch(err => {
        console.log(err)
      })
    },
    backPath: function () {
      this.$router.go(-1)
    },
    showInfo: function (data) {
      console.log(data)
      this.inputValue.lossType = data.value
    },
    showDropInfo: function (data) {
      console.log(data)
      this.inputValue.siteName = data.gatherSite
      this.inputValue.siteId = data.id
      this.inputValue.siteType = data.siteType
    },
    handleData: function () {
      let body = {
        batch: this.inputValue.batch,
        lossReson: this.inputValue.lossReson,
        lossType: this.inputValue.lossType,
        lossWeight: this.inputValue.lossWeight,
        materialName: this.inputValue.materialName,
        remark: this.inputValue.remark,
        siteId: this.inputValue.siteId,
        siteType: this.inputValue.siteType
      }
      if (
        noEmpty(body.batch, '请选择批次号') &&
        noEmpty(body.siteId, '请选择仓库位置') &&
        noEmpty(body.lossWeight, '请输入损耗质量') &&
        noEmpty(body.lossType, '请选择损耗类型')
      ) {
        addLoss(body).then(res => {
          console.log(res)
          this.$message({
            message: res.data,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
@import "./Loss.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/loss/LookDetailNew.vue